// If needed can be extended to accept error names and return only those ones
import { useContext } from 'react';
import { AppErrorContext } from './AppErrorBoundary';
import { AppErrorMap, AppError } from './AppErrorMap';

const useAppErrors = (): AppError[] => {
  const { errors } = useContext(AppErrorContext);

  return errors.map((errName) => AppErrorMap[errName]);
};

export default useAppErrors;
